import React, {
    ReactElement, ReactNode, useCallback, useEffect, useRef,
} from "react";

export interface ScrollableListProps {
    children: ReactNode;
    className?: string;
    onScroll: () => (void | Promise<void>);
}

export default function ScrollableList(props: ScrollableListProps): ReactElement {
    const loader = useRef<HTMLDivElement | null>(null);

    const handleObserver = useCallback(async (entries: IntersectionObserverEntry[]) => {
        const target = entries[0];
        if (target.isIntersecting) {
            await props.onScroll();
        }
    }, [props.onScroll]);

    useEffect(() => {
        const option = {
            root: null,
            rootMargin: "0px",
            threshold: 1.0,
        };

        const observer = new IntersectionObserver(handleObserver, option);

        if (loader.current) {
            observer.observe(loader.current);
        }

        return () => {
            if (loader.current) {
                observer.unobserve(loader.current as Element);
            }
        };
    }, [handleObserver]);

    return (
        <div className={props.className}>
            <div>
                {props.children}
            </div>
            <div ref={loader} />
        </div>
    );
}

ScrollableList.defaultProps = {
    className: undefined,
};
